import AffiliateNotificationsToken from '@apps/maha/admin/tokens/affiliate_notifications'
import Details from '@admin/components/details'
import Button from '@admin/components/button'
import Panel from '@admin/components/panel'
import Edit from '../../affiliate/edit'
import PropTypes from 'prop-types'
import React from 'react'

const Overview = ({ affiliate }) => {

  const signup_page = {
    label: affiliate.signup_pages[0].shortlink.expanded_url,
    className: 'link',
    link: affiliate.signup_pages[0].shortlink.expanded_url
  }

  const details = {
    sections: [
      {
        title: 't(Affiliate Details)',
        items: [
          { label: 't(Affilate Signup Page)', content: <Button { ...signup_page } /> },
          { label: 't(Active Referrals)', content: (
            <>{affiliate.active_referrals_count} / {affiliate.referrals_count}</>
          ) },
          ...(affiliate.service === 'paypal' ? [
            { label: 't(Paypal Email)', content: affiliate.service_id }
          ] : affiliate.service === 'venmo' ? [
            { label: 't(Venmo Username)', content: affiliate.service_id }
          ] : []),
          { label: 't(Commission Rate)', content: affiliate.rate, format: 'rate' },
          { label: 't(Notifications)', content: <AffiliateNotificationsToken value={ affiliate.notifications } /> }
        ]
      }
    ]
  }

  return <Details { ...details } />

}

Overview.propTypes = {
  affiliate: PropTypes.object
}

const mapPropsToPanel = (props, context) => ({
  title: 't(Affiliate)',
  panel: <Overview affiliate={ props.affiliate } />,
  tasks: {
    items: [
      { label: 't(Edit Affiliate)', svg: 'square_pen', modal: Edit}
    ]
  }
})

const mapResourcesToPanel = (props, context) => ({
  affiliate: '/api/admin/team/affiliate'
})

export default Panel(mapResourcesToPanel, mapPropsToPanel)
